import Filter from "../../assets/icon/filter.svg";
import Cross from "../../assets/icon/cross.svg";

import { isoToFormatDate } from "../../functions/formatTime";
import React, { useState, useEffect } from "react";

// SearchBar is an input that allows user to input string,
// and set state of filtered item when input changed
// any item with the substring will be counted as searched
const SearchBar = ({ items, setFunction }) => {
  const [text, setText] = useState("");

  const filter = (substring) => {
    if (substring === "") {
      setFunction(items);
    }
    const filteredItems = [];
    const trimmedSubString = substring.trim();

    // TODO: search with only searchedField
    // if any property contain substring, it counts
    for (let i = 0; i < items.length; i++) {
      for (const prop in items[i]) {
        try {
          let propValue = items[i][prop];

          // filter with data user sees
          // NOTE: I think this will have a lot of bug(not severe, just confusing to user)
          // possible solution: make each row a new object, then filter that row data
          if (propValue === null) {
            continue;
          }

          const ignoreProp = ["_id", "lineId", "__v"];
          if (ignoreProp.includes(prop)) {
            continue;
          }

          if (prop.includes("date") || prop.includes("Date")) {
            propValue = isoToFormatDate(propValue);
          }

          if (propValue.includes(trimmedSubString)) {
            filteredItems.push(items[i]);
            break;
          }
        } catch (err) {
          continue;
        }
      }
    }

    setText(substring);
    setFunction(filteredItems);
  };

  const onInputChange = (event) => {
    filter(event.target.value);
  };

  const clear = () => {
    setText("");
    setFunction(items);
  };

  useEffect(() => {
    filter(text);
  }, [items]);

  return (
    <div className="flex items-center gap-x-2 mb-2 mt-8 mr-8">
      <img src={Filter} className="w-8 h-8" />
      <div className="flex items-center">
        <input
          onChange={onInputChange}
          value={text}
          placeholder="請輸入任意關鍵字"
          className="border-2 rounded p-1 font-chinese w-30"
        />
        <img
          src={Cross}
          onClick={clear}
          className={`w-8 h-8 relative right-8 ${text === "" ? "invisible" : ""} cursor-pointer hover:brightness-75`}
        />
      </div>
    </div>
  );
};

export default SearchBar;
